import { Icon } from "@mui/material";
import { FC } from "react";
import { FavoriteBorder } from "@mui/icons-material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import BookmarkBorderTwoToneIcon from "@mui/icons-material/BookmarkBorderTwoTone";
import ShareTwoToneIcon from "@mui/icons-material/ShareTwoTone";
import PostCardLikeAndComment from "componentsTemplate/PostCardLikeAndComment/PostCardLikeAndComment";
import PostCardSaveAction from "componentsTemplate/PostCardSaveAction/PostCardSaveAction";

export interface TipsCardProps {
  categoria: string;
  adImg: string;
  authorImg: string;
  authorName: string;
  adDate: string;
  adTitle: string;
  likeCount?: number;
  commentsCount?: number;
}

const TipsCard: FC<TipsCardProps> = ({
  categoria = "",
  adImg = "",
  authorImg = "",
  authorName = "",
  adDate = "",
  adTitle = "",
  likeCount = 0,
  commentsCount = 0,
}) => {
  return (
    <div className="bg-white dark:bg-gray-600 rounded-3xl overflow-hidden shadow-md w-[280px] h-full">
      <div className="flex w-[280px] h-[220px] object-cover rounded-t-3xl">
        <img
          className="absolute w-[280px] h-[220px] object-cover rounded-t-3xl"
          alt="photo"
          src={adImg}
          onError={(e: any) => {
            //e.target.onerror = null; // Evita looping infinito caso a segunda imagem também falhe
            e.target.src = 'https://media.istockphoto.com/id/1147544807/de/vektor/miniaturbild-vektorgrafik.jpg?s=612x612&w=0&k=20&c=IIK_u_RTeRFyL6kB1EMzBufT4H7MYT3g04sz903fXAk='; // Defina a URL da imagem alternativa
          }}
        />
        <span className="flex items-center relative h-1/6 top-3 left-3 bg-white font-semibold text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
          {categoria}
        </span>
      </div>
      <div className="flex flex-col items-center justify-between p-1 gap-4">
        <div className="flex items-center justify-start w-full">
          <img
            className="w-[2.5rem] h-[2.5rem] mr-2 object-cover rounded-full"
            alt="Author photo"
            src={authorImg}
          />
          <div>
            <span className=" text-xs font-semibold text-gray-600 w-full">
              {authorName}{" "}
            </span>
            <span className="text-xs text-start text-primary-600 font-semibold w-full">
              • {adDate}
            </span>
          </div>
        </div>
        <div className="flex flex-col text-justify w-full">
          <span className="font-semibold text-sm w-full">{adTitle}</span>
        </div>
        <div className="flex flex-col text-justify w-full">
          <div className="flex items-center flex-wrap justify-between">
            <PostCardLikeAndComment
              likeCount={likeCount}
              commentsCount={commentsCount}
              className="relative"
            />
            <PostCardSaveAction className="relative" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsCard;
